export const formatNumber = (num: number) => {
  if (num <= 999) {
    return num;
  }

  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(1) + 'K';
  }

  if (num >= 1000000 && num < 1000000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }

  if (num >= 1000000000) {
    return (num / 1000000).toFixed(1) + 'B';
  }
};
